<template>
  <div v-if="partner" class="coop-success">
    <img class="coop-success-bg" :src="partner.successBg" alt="您已成功领卡">

    <a class="coop-success-btn" :href="bmwUrl">
      <img :src="partner.successBtn" alt="点击了解新世代车型">
    </a>
  </div>
</template>

<script>
import { getPartner, BMW_NEW_GENERATION_URL } from './partners'

export default {
  name: 'CoopSuccess',
  data() {
    return {
      partner: null,
      bmwUrl: BMW_NEW_GENERATION_URL
    }
  },
  created() {
    this.partner = getPartner(this.$route.params.partner)
    if (!this.partner) {
      this.$router.replace('/')
    }
  }
}
</script>

<style scoped>
.coop-success {
  position: relative;
  min-height: 100vh;
  /* 长图未加载完时的兜底色, 加载后整页被图撑满, 看不到 */
  background-color: #DDE9F6;
}

/* 长图按宽度等比缩放, 高度自然撑开, 页面正常滚动 */
.coop-success-bg {
  display: block;
  width: 100%;
}

/*
 * 按钮压在长图底部(不吸底)。按钮图四周是透明留白, 直接叠在车图上,
 * 可见按钮下沿距图底 103/750 = 13.7vw, 是素材自带的留白, 不用另加间距。
 */
.coop-success-btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
}

.coop-success-btn img {
  display: block;
  width: 100%;
}

.coop-success-btn:active {
  opacity: 0.85;
}
</style>
